import { createSlice } from "@reduxjs/toolkit";
import { fontSettings as configFontSettings } from "config";


const initialState = {
    currentMeeting: {},

    currentMeetingUsers: [],
    currentMeetingParticipants: [],

    currentAgenda: [],
    currentAgendaList: [],

    currentMeetingVoteList: null,
    currentMeetingReviewList: null,


    pageType: {},

    allUsersMeetingList: [],


    allMMList: [],
    init: true,


    allMeetingList: [], // management sayfasında yönettiğim toplantılar
    allReadMeetingList: [], // list sayfasında okuma toplantılari

    fontSettings: configFontSettings.find(font => font.id === "medium") || {},
};



export const meetingSlice = createSlice({
    name: 'meeting',
    initialState,
    reducers: {
        setCurrentMeeting: (state, action) => {
            state.currentMeeting = action.payload
        },
        setCurrentMeetingUsers: (state, action) => {
            state.currentMeetingUsers = action.payload
        },
        setCurrentMeetingParticipants: (state, action) => {
            state.currentMeetingParticipants = action.payload
        },

        setCurrentAgenda: (state, action) => {
            state.currentAgenda = action.payload
        },
        setCurrentAgendaList: (state, action) => {
            state.currentAgendaList = action.payload
        },
        setCurrentMeetingVoteList: (state, action) => {
            state.currentMeetingVoteList = action.payload
        },
        setCurrentMeetingReviewList: (state, action) => {
            state.currentMeetingReviewList = action.payload
        },



        setPageType: (state, action) => {
            state.pageType = action.payload || [];
        },
        setAllMMList: (state, action) => {
            state.allMMList = action.payload
        },

        setFontSettings: (state, action) => {
            state.fontSettings = action.payload
        },
        setAllMeetingList: (state, action) => {
            state.allMeetingList = action.payload
        },
        setAllReadMeetingList: (state, action) => {
            state.allReadMeetingList = action.payload
        },
        setAllUsersMeetingList: (state, action) => {
            state.allUsersMeetingList = action.payload
        }




    },
    // extraReducers: (builder) => {
    //     builder.addCase(getListOfCreateMeetingUserListAPI.fulfilled, (state, action) => {
    //         state.listOfCreateMeetingUserList = action.payload;
    //     });
    // }
});



export const { setCurrentMeeting, setCurrentAgenda, setCurrentAgendaList,


    pageType, setPageType,
    currentMeetingUsers,
    setCurrentMeetingUsers,

    currentMeetingReviewList,
    setCurrentMeetingReviewList,

    currentMeetingVoteList,
    setCurrentMeetingVoteList,

    currentMeetingParticipants,
    setCurrentMeetingParticipants,


    allMMList,
    setAllMMList,



    fontSettings,
    setFontSettings,

    allMeetingList,
    setAllMeetingList,

    allReadMeetingList,
    setAllReadMeetingList,

    allUsersMeetingList,
    setAllUsersMeetingList


} = meetingSlice.actions;



export default meetingSlice.reducer;